import { with1ezpy3gn0rpui as with_0 } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/PartyId.mjs';
import { SavePlayerMutation13ci6nh8jmmgu as SavePlayerMutation } from './schema/SavePlayerMutation.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Accepted_instancehwhu2w41uegl as Accepted_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatcher39hthxqv8voqz as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/SavePlayerCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toSerializable3fb4aia8ysz5b as toSerializable } from './SdkPairAssignmentDocumentSave.mjs';
import { Companion_instance19mvqqhuhhta7 as Companion_instance } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { SavePlayerInput3s7vno6nbe1ix as SavePlayerInput } from './schema/type/SavePlayerInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  // Inline function 'kotlin.with' call
  yield* this.n6r(new (SavePlayerMutation())(input(with_0(command.j2l_1, command.k2l_1))), $completion);
  return Accepted_instance;
}
var SdkSavePlayerCommandDispatcherClass;
function SdkSavePlayerCommandDispatcher() {
  if (SdkSavePlayerCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSavePlayerCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSavePlayerCommandDispatcherClass = $;
  }
  return SdkSavePlayerCommandDispatcherClass;
}
function input(_this__u8e3s4) {
  var tmp = toSerializable(_this__u8e3s4.v2a_1.y2a_1);
  var tmp_0 = Companion_instance.e47(_this__u8e3s4.v2a_1.d2b_1);
  var tmp_1 = Companion_instance;
  var tmp0_safe_receiver = _this__u8e3s4.v2a_1.e2b_1;
  return new (SavePlayerInput())(_this__u8e3s4.u2a_1, _this__u8e3s4.v2a_1.x2a_1, _this__u8e3s4.v2a_1.z2a_1, _this__u8e3s4.v2a_1.a2b_1, tmp, _this__u8e3s4.v2a_1.b2b_1, _this__u8e3s4.v2a_1.c2b_1, tmp_0, tmp_1.e47(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v1_1), toList(_this__u8e3s4.v2a_1.f2b_1));
}
//region block: exports
export {
  SdkSavePlayerCommandDispatcher as SdkSavePlayerCommandDispatcher2k2b5uhezxdlq,
  perform as perform161737cslumnq,
};
//endregion

//# sourceMappingURL=SdkSavePlayerCommandDispatcher.mjs.map
